export default __webpack_public_path__ + "static/media/caen14.72109e49.jpg";